/*
 * @Author: Lina
 * @Date: 2020-07-27 13:20:31
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-04 19:01:35
 */
// getHotelList
import React, { PureComponent } from 'react';
import api from '@/services/hotelApi';
import dayjs from 'dayjs';
import './index.scss'
import downArrow from '@/assets/images/hotel/downArrow.png'
import CityListSelect from '../CityListSelect'
import CrgtEvent from '../CrgtEvent';

class HotelRankList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showCityModal: false,
      hotelList: [],
      cityList: [],
      currentCity: {
        cityName: '北京',
      cityCode: "110100",
      lng: 116.40717,
      lat: 39.90469
      }
      
    }
  }
  async componentDidMount() {
    try {
      await this.fetchHotelCityList()
    } catch (err) {
      console.log(err)
    }


  }
  fetchHotelCityList = async () => {
    const res = await api.rankHotelByCity.getCityList({searchType: 'RANK_HOTEL',});
    if (res.code !== 0) return;
    const {records} = res.data;
    this.setState({cityList: records}, this.fetchCurrentCity )
  }

  fetchCurrentCity = async() =>{
    const {cityList} = this.state;
    const location = await api.getLocation();
     if(location.status === 200 && location.data.status === 0) {
       
       const locationInfo = location.data
      const {adcode} = locationInfo.result.ad_info;
      const currentCity = cityList.find(city=>(city.cityCode.includes(parseInt(Number(adcode)/10000)))) 
      console.log('current', currentCity)
      if(currentCity) {
        this.setState({currentCity:currentCity}, this.fetchHotelList)
      }
     } else {
      await this.fetchHotelList()
     }
  }
  fetchHotelList = async () => {
    const { currentCity } = this.state
    const param = {
      // cityCode: location.data.result.ad_info.adcode,
      cityCode: currentCity.cityCode,
      dateCheckIn: dayjs().format('YYYY-MM-DD'),
      dateCheckOut: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      longitude: currentCity.lng,
      latitude: currentCity.lat,
      searchType: 'RANK_HOTEL',
      size: 20,
      current: 1,
    }
    console.log('fetch 122')
    const res = await api.rankHotelByCity.getHotelList(param)
    if (res.code !== 0) return;
    console.log('fetch 122 rees',res)
    this.setState({
      hotelList: res.data.records || []
    })
  }

  onToggleCityModal = ()=>{
    this.setState(prevState=>({showCityModal: !prevState.showCityModal}))
  }

  onCityClick= async (data) => {
    this.setState({currentCity: data},  this.fetchHotelList)
  }
  
  goToHotelDetail=(data)=>{
    const {currentCity} = this.state;
    const {hotelId, cityCode} = data.hotelBaseInfo;
    const params = {
      nativePage:"hotelDetail",
      nativePath:  `needlogin=true&goodsType=1&hotelId=${hotelId}&latitude=${currentCity.lat}&longitude=${currentCity.lng}&cityCode=${cityCode}`

    }
    CrgtEvent.openNativeView(params)
  }
  render() {
    const { hotelList, cityList, currentCity, showCityModal } = this.state;
    const {locationBgColor,
    hotelCardBgColor,
    hotelCardTitleColor,
    hotelCardTypeColor,
    hotelCardScoreColor,
    hotelCardAreaColor,
    hotelCardTagColor,
    hotelCardTagBorderColor,
    hotelCardPriceColor} = this.props
    return (
      <div className="HotelList" >
        {
          hotelList.map((item, key) => (
            <div className="hotelModule" key={key} style={{backgroundColor: hotelCardBgColor}} onClick={()=>this.goToHotelDetail(item)}>
              {key < 3 && <div className={`rankingTop topImg${(key+1)}`} />}
              <div className="ranking">
              
              <div className="rankingTag"> {`TOP${key+1}`}</div>
                </div>
              <div className="hotelLeft">
                <img src={item.hotelBaseInfo.frontImg} alt="" />
              </div>
              <div className="hotelRight">
                <div className="title" style={{color: hotelCardTitleColor}}>
                  <div className="hotelTitle">{item.hotelBaseInfo.name}</div>
                <div className="hotelStarStr" style={{color: hotelCardTypeColor}}>{item.hotelBaseInfo.hotelStarStr}</div>
                </div>
                <div className="score" style={{color: hotelCardScoreColor}}>{(item.hotelBaseInfo.avgScore/10).toFixed(1)}<span>分</span></div>
                <p className="tradingAreaName" style={{color: hotelCardAreaColor}}>{item.hotelBaseInfo.address}</p>
                <div className="tagModule">
                  {
                    item.hotelBaseInfo.tradingAreaName && item.hotelBaseInfo.tradingAreaName.split('/').map(
                      item => <div className="themeTagStrs" style={{color: hotelCardTagColor, borderColor:hotelCardTagBorderColor}} key={item}>{item}</div>)
                  }
                  </div>
                <p className="lowestPrice" style={{color: hotelCardPriceColor}}><span>¥</span>{item.hotelBaseInfo.lowestPrice}<span>起</span></p>
              </div>
            </div>
          ))
        }
        <div className="cityLocation" style={{backgroundColor:locationBgColor}} onClick={this.onToggleCityModal}>
          {currentCity.cityName}
          <img src={downArrow} alt="arrow" />
        </div>
        {
          showCityModal && <CityListSelect list={cityList} onClose={this.onToggleCityModal} onCityClick={this.onCityClick} initInfo={currentCity} />
        }
      </div>
    )
  }
}

export default HotelRankList
